
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/packs/userFrontend/features/publication/components/WorkWithShopWorkCassettes/uiParts/PremiumBanner/styles.css.ts.vanilla.css\",\"source\":\"Ll8xeWh3MzB5MCB7CiAgZGlzcGxheTogYmxvY2s7CiAgbWF4LXdpZHRoOiA3MDBweDsKICBtYXJnaW46IDI0cHggNXB4OwogIHRyYW5zaXRpb246IG9wYWNpdHksIDAuMnM7Cn0KLl8xeWh3MzB5MDpob3ZlciwgLl8xeWh3MzB5MDpmb2N1cyB7CiAgb3BhY2l0eTogMC43Owp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDc2OHB4KSB7CiAgLl8xeWh3MzB5MCB7CiAgICBtYXJnaW46IDQwcHggYXV0bzsKICB9Cn0=\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/packs/userFrontend/features/publication/components/WorkWithShopWorkCassettes/uiParts/PremiumBanner/styles.css.ts.vanilla.css\",\"source\":\"Ll8xeWh3MzB5MCB7CiAgZGlzcGxheTogYmxvY2s7CiAgbWF4LXdpZHRoOiA3MDBweDsKICBtYXJnaW46IDI0cHggNXB4OwogIHRyYW5zaXRpb246IG9wYWNpdHksIDAuMnM7Cn0KLl8xeWh3MzB5MDpob3ZlciwgLl8xeWh3MzB5MDpmb2N1cyB7CiAgb3BhY2l0eTogMC43Owp9CkBtZWRpYSBzY3JlZW4gYW5kIChtaW4td2lkdGg6IDc2OHB4KSB7CiAgLl8xeWh3MzB5MCB7CiAgICBtYXJnaW46IDQwcHggYXV0bzsKICB9Cn0=\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
